import { render, staticRenderFns } from "./positioning.vue?vue&type=template&id=5132cbeb&scoped=true&"
import script from "./positioning.vue?vue&type=script&lang=js&"
export * from "./positioning.vue?vue&type=script&lang=js&"
import style0 from "./positioning.vue?vue&type=style&index=0&id=5132cbeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5132cbeb",
  null
  
)

export default component.exports